import { render, staticRenderFns } from "./PzPhoneNumber.vue?vue&type=template&id=31a8dc17"
import script from "./PzPhoneNumber.vue?vue&type=script&lang=js"
export * from "./PzPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PzPhoneNumber.vue?vue&type=style&index=0&id=31a8dc17&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a8dc17')) {
      api.createRecord('31a8dc17', component.options)
    } else {
      api.reload('31a8dc17', component.options)
    }
    module.hot.accept("./PzPhoneNumber.vue?vue&type=template&id=31a8dc17", function () {
      api.rerender('31a8dc17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/PzPhoneNumber.vue"
export default component.exports